var map = {
	"./AAAFX-logo.png": "cdb4",
	"./Blackstone-logo.png": "481f",
	"./FXView-logo.png": "02cd",
	"./FinancialSpreads-logo.png": "540f",
	"./GCCBrokers-logo.png": "9831",
	"./ICMAP-logo.png": "474f",
	"./ICMCapital-logo.png": "68d4",
	"./ICMEU-logo.png": "084b",
	"./ICMMENA-logo.png": "d65e",
	"./ICMMU-logo.png": "2e5e",
	"./ICMSC-logo.png": "a586",
	"./ICMVC-logo.png": "bf8f",
	"./OneTradingMarkets-logo.png": "e13a",
	"./OrbitInvest-logo.png": "a48f",
	"./PolarisMarkets-logo.png": "3ea0",
	"./Promena-logo.png": "4cad",
	"./TD365-logo.png": "ec44",
	"./TDSouthAfrica-logo.png": "646d",
	"./TradiNext-logo.png": "7059",
	"./VCGMarkets-logo.png": "27db",
	"./trade-direct-logo.png": "124d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f992";